// extracted by mini-css-extract-plugin
export default {"overlay":"umEL74ECM7ZO2NIg8qcY","spinnerContainer":"LFBxwDwSWwmWT2WGxpZc","spinner":"WlZSVATyQVId5dxmIRkD","spin":"ZyIyxa0I8g8dFjLJTOzh","message":"c52qlwU3lCSU2dM174Om"};